import React, { useState } from 'react';
import { Link } from 'react-router-dom';


export default function HeaderNav() {
    const [navbar, setNavbar] = useState(false);

    let continentCategoryList = [{"land_id":"51","continent_ko":"동남아시아","continent_code":"southeastasia"},{"land_id":"111","continent_ko":"동아시아","continent_code":"eastasia"},{"land_id":"14","continent_ko":"오세아니아","continent_code":"oceania"},{"land_id":"136","continent_ko":"유럽","continent_code":"europe"},{"land_id":"23","continent_ko":"중동","continent_code":"middleeast"}];

    return (

        <>
        <nav  className="w-full bg-black shadow">
            <div className="justify-between px-3 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
                <div>
                    <div className="flex items-center justify-between py-3 md:py-5 md:block">
                        <Link to={"/"}>
                            <h2 className="text-2xl font-bold text-white">트래블노트</h2>
                        </Link>
                        <div className="md:hidden">
                            <button
                                className="p-2 text-white rounded-md outline-none focus:border-gray-400 focus:border"
                                onClick={() => setNavbar(!navbar)}
                            >
                                {navbar ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
                            navbar ? "block" : "hidden"
                        }`}
                    >
                        <ul className="items-center justify-center space-y-8 md:flex md:space-x-6 md:space-y-0">
                            
                            <li key={'japan'} >
                                <Link  to={"/country/japan"} 
                                className="text-white hover:text-blue-600">일본</Link>
                            </li>

                            

                            <li key={'japan'} >
                                <Link  to={"/city/osaka"} 
                                className="text-white hover:text-blue-600">오사카</Link>
                            </li>

                            <li key={'japan'} >
                                <Link  to={"/city/tokyo"} 
                                className="text-white hover:text-blue-600">도쿄</Link>
                            </li>

                            <li key={'vietnam'} >
                                <Link  to={"/country/vietnam"} 
                                className="text-white hover:text-blue-600">베트남</Link>
                            </li>


                            <li key={'thailand'} >
                                <Link  to={"/country/thailand"} 
                                className="text-white hover:text-blue-600">태국</Link>
                            </li>

                            <li key={'united-states'} >
                                <Link  to={"/country/united-states"} 
                                className="text-white hover:text-blue-600">미국</Link>
                            </li>

                            {continentCategoryList.map((it,index)=>(
                            <li key={index} >
                                <Link  to={"/continent/"+it.continent_code} 
                                className="text-white hover:text-blue-600">{it.continent_ko}</Link>
                            </li>
                        ))}


                        </ul>
                    </div>
                </div>
            </div>
        </nav>
        
        </>
    );
}



